import React from 'react'

export const IconReport = ({ color = '#757575' }) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10 10H8V4H10V10ZM8 12H10V14H8V12ZM12.73 0H5.27L0 5.27V12.73L5.27 18H12.73L18 12.73V5.27L12.73 0Z' fill={color} />
  </svg>
)
